import type { JSONContent } from '@tiptap/core'
import { tagAttributeValue, tagNodeName } from '@/services/forms/tmTiptap/const'
import { parseToJsonTextAndTags, type ParsedTextOrTag } from '@/services/forms/tmTiptap/utils/parseToJsonTextAndTags'
import { textToJsonTextAndTags } from '@/services/forms/tmTiptap/utils/textToJsonTextAndTags'

const toParagraph = (content: JSONContent[]): JSONContent => ({
  type: 'paragraph',
  content: content.length ? content : undefined,
})

const parsedItemsToParagraphs = (items: ParsedTextOrTag[]): JSONContent[] => {
  const paragraphs: JSONContent[][] = [[]]

  items.forEach((item) => {
    if (item.type === 'text') {
      item.value.split('\n').forEach((line, lineIndex) => {
        if (lineIndex > 0) {
          paragraphs.push([])
        }
        if (line) {
          paragraphs[paragraphs.length - 1].push({ type: 'text', text: line })
        }
      })
      return
    }

    paragraphs[paragraphs.length - 1].push({
      type: tagNodeName,
      attrs: { [tagAttributeValue]: item.value },
    })
  })

  return paragraphs.map(toParagraph)
}

export const textToJsonParagraphs = (text: string, isJsonContent = false): JSONContent[] => {
  if (isJsonContent) {
    return parsedItemsToParagraphs(parseToJsonTextAndTags(text, true))
  }

  return text.split('\n').map((paragraph) => toParagraph(textToJsonTextAndTags(paragraph)))
}
